import React, { FC, useContext, useState } from 'react'
import {
	Button,
	Col,
	Slider,
	Container
} from '@microfrontends/react-components'
import { EventItem } from '../components/EventItem'
import { EventHotItem } from '../components/EventHotItem'
import { IEvent, IEventResult } from '../assets/types'
import { events } from '../../../services/event'
import {
	STBanner,
	STButton,
	STEventWrapper,
	STContainer,
	STDescription,
	STDivider,
	STContent,
	STEventHot,
	STSubTitle,
	STHeaderWrapper,
	STTitle
} from './styles'
import AppContext from '../../../context/AppContext'
import RecommendJobs from '../../../containers/NumerologyContainerV2/components/RecommendJobs'

interface IEventProps {
	eventHots: IEvent[]
	events: IEventResult
}

const UTM = {
	utm_source: 'event',
	utm_medium: 'job-will-love',
	utm_campaign: 'homepage'
}

const Event: FC<IEventProps> = ({ eventHots, ...props }) => {
	const [eventsResult, setEventsResult] = useState<IEventResult>(props.events)
	const { t, languageCode } = useContext(AppContext)
	const loadMoreEvents = async () => {
		try {
			const { result } = await events(eventsResult.page + 1, 10)
			setEventsResult((eventsResult) => ({
				...eventsResult,
				events: [...eventsResult.events, ...result.events]
			}))
		} catch (error) {
			console.log('loadMoreEvents ', error)
			return null
		}
	}

	const totalEventText =
		eventsResult?.total_count > 1 ? t('events') : t('event')
	const bannerEventImage = `${process.env.BASE_IMAGES_URL}/images/event-banner-${languageCode}.png`
	return (
		<STContainer>
			<STBanner>
				<img src={bannerEventImage} />
			</STBanner>
			<Container>
				<STContent>
					<STTitle>{t('Featured Events')}</STTitle>
					<STDescription textAlign='center'>
						{t('Featured events from leading companies')}
					</STDescription>
					<STEventHot>
						<Slider
							id='event-hot'
							// autoEnable={eventHots.length > 1}
							// autoTime={2000}
							pagination={{ maxShow: 5 }}
							container={{ style: { width: '100%' } }}
						>
							{eventHots.map((item) => (
								<EventHotItem key={item.eventId} event={item} />
							))}
						</Slider>
					</STEventHot>

					{eventsResult?.total_count > 0 && (
						<>
							<STHeaderWrapper>
								<STSubTitle>{t('More events')}</STSubTitle>
								<STDivider>
									<div></div>
									<div>
										<hr />
										<hr />
									</div>
								</STDivider>
							</STHeaderWrapper>
							<STDescription>
								{eventsResult?.total_count} {totalEventText}
							</STDescription>

							<STEventWrapper>
								{eventsResult?.events?.map((event) => (
									<EventItem
										key={event.eventId}
										event={event}
									/>
								))}
							</STEventWrapper>
						</>
					)}

					{eventsResult?.has_more && (
						<STButton onClick={loadMoreEvents}>
							<Button type='outline'>{t('View More')}</Button>
						</STButton>
					)}
				</STContent>
			</Container>
			<Col>
				<RecommendJobs
					title={t('Job you will love')}
					utm={UTM}
					containerWidth='lg'
				/>
			</Col>
		</STContainer>
	)
}

export default Event
